import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";
import ko from "vee-validate/dist/locale/ko.js";
import en from "vee-validate/dist/locale/en.js";

let userLocale = navigator.language || navigator.userLanguage;
    userLocale = userLocale.substring(0, 2);

/* ko.js 에 없는 문구가 필요한 경우 추가 작성 */
ko.messages.required = field => `${field} 을/를 입력하세요.`;
en.messages.required = field => `Please enter ${field}`;

Vue.use(VeeValidate, {
  locale: userLocale,
  dictionary: {
    ko: {
      attributes: {
        userId: "아이디",
        name: "이름",
        password: "비밀번호",
        email: "이메일",
        mobile: "전화번호",
        cellPhoneNo : "전화번호",
        address: "주소",
        groupName: "그룹이름",
        description: "설명",
        certKey: "인증번호"
      },
      messages: {}
    },
    en: {
      attributes: {
        userId: "userId",
        name: "Name",
        password: "Password",
        email: "Email",
        mobile: "Phone number",
        cellPhoneNo : "Phone number",
        address: "Address",
        groupName: "Group name",
        description: "Description",
        certKey: "Authentication number"
      },
      messages: {}
    }
  }
});
Validator.localize(userLocale, userLocale);

export default Validator;



// WEBPACK FOOTER //
// ./src/js/store/modules/validation.js